import $ from "jquery";
import fb from "@bd-core/firebase";
import GameLogic from "@bd-core/game-logic";
import bdjs from "@bd-core/bdjs";
import { DotLottie } from "@lottiefiles/dotlottie-web";

export const ResultPage = () => {
    const isResultPage = $("#result-page").length > 0;
    if (!isResultPage) return false;

    const elms = {
        playerAmount: $(".js-player-amount"),
    };

    GameLogic.listenGameProgressChanged();

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame();
    } catch (e) {
        console.error(e);
    }

    const handlePlayersCount = (e, eventData) => {
        const players = eventData?.data;
        const onlinePlayers = players.filter((player) => player.isOnline);
        const playerAmount = onlinePlayers.length > 0 ? onlinePlayers.length - 1 : 0; // exclude the leader or facilitator

        const $playerAmount = $(elms.playerAmount);
        $playerAmount.text(playerAmount);
    };

    new DotLottie({
        autoplay: true,
        loop: true,
        // @ts-ignore
        canvas: document.querySelector("#dotlottie-canvas"),
        // src: "https://lottie.host/4db68bbd-31f6-4cd8-84eb-189de081159a/IGmMCqhzpt.lottie", // or .json file
        src: "/wp-content/themes/kpn/assets/images/lottie/confetti.lottie",
    });

    bdjs.listen("bd__playersStateChanged", handlePlayersCount);
};
